import { GridActionsCellItem, GridColumns, GridRowParams } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import { filterOperators, numberFilterOperators } from '../../../../constants';
import { baseCell } from '../cells/base-cell';
import { dateCell } from '../cells/date-cell';
import ConfirmationDeleteTableDialog from 'components/helpers/ConfirmationGridDelete';
import EditIcon from '@mui/icons-material/Edit';

export function TransportActiveDocumentLinesColumns(
  isStatusNew: boolean,
  handleDelete?: any,
  handleEdit?: (id: number) => void,
  disableEdit?: boolean,
  isClosed?: boolean
): GridColumns {
  const translationPrefix = 'pages.active-ddt.product-list';
  const { t } = useTranslation();

  const columns: GridColumns = [
    {
      field: 'quantity',
      headerName: t(`${translationPrefix}.quantity`),
      width: 80,
      type: 'number',
      filterable: false,
      renderCell: baseCell
    },
    {
      field: 'product_code',
      headerName: t(`${translationPrefix}.product_code`),
      width: 175,
      filterable: false,
      renderCell: baseCell
    },
    {
      field: 'product_description',
      headerName: t(`${translationPrefix}.product_description`),
      width: 250,
      filterable: false,
      renderCell: baseCell
    },
    {
      field: 'order_code',
      headerName: t(`${translationPrefix}.order`),
      width: 125,
      filterable: false,
      renderCell: baseCell
    },
    {
      field: 'product_batch',
      headerName: t(`${translationPrefix}.product_batch`),
      width: 100,
      filterable: false,
      renderCell: baseCell
    },
    {
      field: 'expiration_date',
      headerName: t(`${translationPrefix}.expiration_date`),
      width: 100,
      filterable: false,
      renderCell: dateCell
    },
    {
      field: 'notes',
      headerName: t(`${translationPrefix}.notes`),
      filterable: false,
      width: 250,
      renderCell: baseCell
    },
    {
      field: 'order_code',
      headerName: t(`${translationPrefix}.order`),
      width: 125,
      renderCell: baseCell
    }
  ];

  if (isStatusNew && !disableEdit && !isClosed) {
    columns.push({
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      getActions: (params: GridRowParams) => {
        const actions = [];
        actions.push(
          <GridActionsCellItem
            key={1}
            label={t('actions.edit')}
            icon={<EditIcon />}
            onClick={() => handleEdit(params.row)}
          />
        );
        actions.push(
          <ConfirmationDeleteTableDialog handleDelete={handleDelete} id={params.row.id} />
        );
        return actions;
      }
    });
  }

  return columns;
}
